import React, {useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';

import Modal from '@ThemesApp/common/components/Modal/Modal';
import Feedback from '@Themes/natucare/modules/Feedback/Feedback';
import FeedbackModal from '@Themes/natucare/components/Modal/components/FeedbackModal/FeedbackModal';
import FeedbackPositive from '@Themes/natucare/components/Feedback/components/FedbackPositive';
import FeedbackNegative from '@Themes/natucare/components/Feedback/components/FeedbackNegative';

import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

import DATA from '@/data/common.data';
import ERROR_VALUES from '@/data/errors.data';
import FEEDBACK_DATA from '@/data/feedback.data';

import {sendForm} from './api/sendForm';

const FeedbackApi = ({
                       locale,
                       requestUri,
                       hideButton,
                       state
                     }) => {
  const [
    modal,
    setModal
  ] = useState({
    open: false,
    type: ''
  });

  const [
    form,
    setForm
  ] = useState({
    submitting: false,
    error: false,
    errorMsg: '',
    sending: false
  });

  const formRef = useRef();

  useEffect(() => {
    if (!form.error && form.submitting) {
      setForm({
        sending: true,
        errorMsg: ''
      });

      const formData = new FormData(formRef.current);

      formData.set(FEEDBACK_CONSTANTS.SITE_ID_NAME, 2);
      formData.set(FEEDBACK_CONSTANTS.REQUEST_URI_NAME, requestUri);

      if (!formData.get(FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME)) {
        formData.set(FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME, 'positive_feedback');
      }

      if (formData.get(FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME) && !formData.get(FEEDBACK_CONSTANTS.FEEDBACK_NAME)) {
        formData.set(FEEDBACK_CONSTANTS.FEEDBACK_NAME, formData.get(FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME));
      }

      sendForm(formData)
        .then(response => response.text())
        .then(result => {

          if (result === FEEDBACK_CONSTANTS.RESPONSE_FAILURE) {
            setForm({
              sending: false,
              submitting: false,
              error: true,
              errorMsg: ERROR_VALUES[locale].API_ERROR
            });
          }

          if (result === FEEDBACK_CONSTANTS.RESPONSE_OK) {
            setForm({
              sending: false,
              submitting: false,
              error: false,
              errorMsg: ''
            });

            setModal({
              open: false
            });

            if (state?.open) {
              state.open = false;
            }
          }
        })
        .catch(error => {
          setForm({
            errorMsg: ERROR_VALUES[locale].API_ERROR
          });
        });
    }
  }, [form, modal, requestUri]);

  const formValidation = () => {
    if (formRef.current) {
      const formData = new FormData(formRef.current);

      return !((formData.get(FEEDBACK_CONSTANTS.FEEDBACK_NAME)?.length > 0) ||
        (formData.get(FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME)?.length > 0));
    }
  };

  const handleFormSubmit = async event => {
    event.preventDefault();

    const hasError = formValidation();

    setForm({
      error: hasError,
      submitting: true,
      sending: false,
      errorMsg: hasError ? ERROR_VALUES[locale].FORM_ERROR : ''
    });
  };

  const handleModalClose = () => {
    if (state?.open) {
      state.open = false;
    }

    setModal({
      open: false,
      error: false,
      sending: false,
      type: ''
    });

    setForm({
      error: false
    });
  };

  const handleClick = type => {
    setModal({
      open: true,
      type
    });
  };

  return <>
    {!hideButton && <Feedback label={DATA[locale].feedback.label}>
      <FeedbackPositive onClick={handleClick.bind(this, FEEDBACK_CONSTANTS.POSITIVE_MODAL_KEY)}/>
      <FeedbackNegative onClick={handleClick.bind(this, FEEDBACK_CONSTANTS.NEGATIVE_MODAL_KEY)}/>
    </Feedback>}
    {(typeof document !== 'undefined') ? createPortal(
      <Modal
        onClose={handleModalClose}
        open={state ? state.open : modal.open}>
        <FeedbackModal
          {...(FEEDBACK_DATA[locale][state?.type || modal.type])}
          ref={formRef}
          onSubmit={handleFormSubmit}
          onClose={handleModalClose}
          loading={form.sending}
          error={form.error}
          errorMsg={form.errorMsg}/>
      </Modal>, document.body) : ''}
  </>;
};

export default FeedbackApi;
